/* ============================================================
   Watch Reserves — cart line controls.

   Quantity and remove go through /cart/change.js and re-render this one
   section via Shopify's Section Rendering API, rather than reloading the
   page the way the Framer version's React refetch effectively did.
   ============================================================ */
(function () {
  'use strict';

  var root = document.querySelector('[data-wr-cart-root]');
  if (!root) return;
  var sectionId = root.dataset.sectionId;
  var busy = false;

  function showError(message) {
    var box = document.querySelector('[data-wr-cart-error]');
    if (!box) return;
    box.textContent = message;
    box.hidden = !message;
    if (message) setTimeout(function () { box.hidden = true; }, 5000);
  }

  function updateCartBadge(count) {
    var link = document.querySelector('[data-wr-cart-link]');
    if (!link) return;
    var badge = link.querySelector('[data-wr-cart-count]');
    if (count > 0 && !badge) {
      badge = document.createElement('span');
      badge.className = 'wr-cart-badge';
      badge.setAttribute('data-wr-cart-count', '');
      link.appendChild(badge);
    }
    if (count === 0 && badge) badge.remove();
    else if (badge) badge.textContent = count > 9 ? '9+' : String(count);
  }

  function change(line, quantity, lineEl) {
    if (busy) return;
    busy = true;
    if (lineEl) lineEl.classList.add('is-busy');

    /* The section swap below replaces the very button that was just
       pressed, so focus falls back to the document and a keyboard user has
       to tab from the top again after every +/- (WCAG 2.4.3). Remember
       which control this was so it can be re-focused on the new markup. */
    var activeEl = document.activeElement;
    var focusLine = activeEl && activeEl.dataset ? activeEl.dataset.wrQty : null;
    var focusTo = activeEl && activeEl.dataset ? activeEl.dataset.wrTo : null;

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity, sections: sectionId })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('change failed');
        return r.json();
      })
      .then(function (cart) {
        updateCartBadge(cart.item_count);

        var html = cart.sections && cart.sections[sectionId];
        var host = document.getElementById('shopify-section-' + sectionId);
        if (!html || !host) {
          // No section markup came back — fall back to a reload rather than
          // leaving stale totals on screen next to a changed cart.
          window.location.reload();
          return;
        }
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var fresh = parsed.getElementById('shopify-section-' + sectionId);
        host.innerHTML = fresh ? fresh.innerHTML : parsed.body.innerHTML;
        bind();
        restoreFocus(focusLine, focusTo);
        if (window.wrAnnounce) window.wrAnnounce('Cart updated.');
      })
      .catch(function () {
        showError("We couldn't update your cart. Please try again.");
        if (lineEl) lineEl.classList.remove('is-busy');
      })
      .finally(function () { busy = false; });
  }


  function restoreFocus(focusLine, focusTo) {
    if (!focusLine) return;
    // Quantity changed, so the button's data-wr-to has changed with it —
    // match on the line and the direction rather than the old value.
    var line = document.querySelector('[data-wr-line="' + focusLine + '"]');
    if (!line) return;
    var buttons = line.querySelectorAll('[data-wr-qty]');
    var target = null;
    for (var i = 0; i < buttons.length; i++) {
      if (buttons[i].dataset.wrTo === focusTo) { target = buttons[i]; break; }
    }
    (target || buttons[0] || line).focus();
  }

  function bind() {
    document.querySelectorAll('[data-wr-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var line = Number(btn.dataset.wrQty);
        var to = Number(btn.dataset.wrTo);
        if (to < 0) return;
        change(line, to, btn.closest('.wr-line'));
      });
    });
  }

  bind();
})();
